import { render, staticRenderFns } from "./CbsFilter.vue?vue&type=template&id=36bf8d0e&scoped=true"
import script from "./CbsFilter.vue?vue&type=script&lang=js"
export * from "./CbsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bf8d0e",
  null
  
)

export default component.exports